import React from "react";
import styles from "./ProfilePage.module.scss";
import { IAdminFireBase } from "@/store/models/admin.models";
import { withAdmin } from "@/services/withAdmin";
import { calculateAge } from "@/helpers/calculateAge";
import { useLocation, useNavigate } from "react-router-dom";
import { IUser, Profile } from "@/store/models/users.models";
import Layout from "@/components/Layout/Layout";

const ProfilePageCmp: React.FC<{ admin: IAdminFireBase }> = ({ admin }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const profile: Profile = location.state.profile;
  const user: IUser = location.state.user;

  const handleNavigation = (contentType: string) => {
    navigate(`/users/${user.email}/${profile.name}/${contentType}`, {
      state: { profile },
    });
  };

  return (
    <Layout admin={admin}>
      <div className={styles.profileDetails}>
        <div className={styles.characterCard}>
          <div className={styles.characterLeft}>
            <div className={styles.characterInfo}>
              <p className={styles.characterName}>{profile.name}</p>
              <p className={styles.characterYears}>
                {`${calculateAge(profile.birthday)} years old`}
              </p>
            </div>
          </div>
        </div>
        <div className={styles.profileActivity}>
          <section
            className={styles.profileActivityItem}
            onClick={() => handleNavigation("liked videos")}
          >
            Liked videos
          </section>
          <section
            className={styles.profileActivityItem}
            onClick={() => handleNavigation("watched videos")}
          >
            Watched videos
          </section>
          <section
            className={styles.profileActivityItem}
            onClick={() => handleNavigation("liked songs")}
          >
            Liked songs
          </section>
          <section
            className={styles.profileActivityItem}
            onClick={() => handleNavigation("listened songs")}
          >
            Listened songs
          </section>
          <section
            className={styles.profileActivityItem}
            onClick={() => handleNavigation("generated books")}
          >
            Generated books
          </section>
        </div>
      </div>
    </Layout>
  );
};

export const ProfilePage = withAdmin(ProfilePageCmp);
ProfilePageCmp.displayName = "ProfilePageCmp";

